import { readStates } from '@/constants/lifecycle';
import findResult from '@/utils/resultsHelper';
import { configurationStates } from '../constants';

const initialState = {
  activeApprovalOpen: false,
  configurations: {
    all: {
      results: [],
      ...readStates,
    },
  },
};

export const configurationsResult = (result) => ({
  ...result,
  ...configurationStates,
});

export const findConfigurations = ({ configurations }, { category }) => configurations[category];

export const findConfiguration = ({ configurations }, { category, code }, attribute = 'code') => (
  findResult(configurations, category, code, attribute)
);

export default initialState;
